(function () {
  var STYLE_ID = 'hp-product-page-polish-v42-style';

  function cleanText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/[־–—]/g, '-')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
/* =========================================================
   HeroPack product page polish v42
   1) Top HeroPack check lines RTL alignment
   2) Collapsible sections typography / RTL / answers
   ========================================================= */

#MainContent .hp-top-bullets-v42,
#MainContent .hp-top-bullets-v42 * ,
#MainContent .hp-collapsible-v42-section,
#MainContent .hp-collapsible-v42-section *{
  box-sizing:border-box!important;
}

/* =========================================================
   1) Top HeroPack check lines
   ========================================================= */

#MainContent .product__info-container .product__description{
  direction:rtl!important;
}

#MainContent .hp-top-bullets-v42{
  width:100%!important;
  max-width:390px!important;
  margin:8px auto 16px!important;
  padding:0 8px 0 0!important;
  direction:rtl!important;
  text-align:right!important;
}

#MainContent .hp-top-bullets-v42-intro{
  width:100%!important;
  margin:0 0 8px!important;
  padding:0!important;
  direction:rtl!important;
  text-align:center!important;
  color:#33432a!important;
  font-family:Assistant, Arial, sans-serif!important;
  font-size:17px!important;
  line-height:1.45!important;
  font-weight:800!important;
}

#MainContent .hp-top-bullets-v42-line{
  width:100%!important;
  display:flex!important;
  flex-direction:row!important;
  align-items:flex-start!important;
  justify-content:flex-start!important;
  gap:8px!important;
  margin:6px 0!important;
  padding:0!important;
  direction:rtl!important;
  text-align:right!important;
  color:#33432a!important;
  font-family:Assistant, Arial, sans-serif!important;
  font-size:17px!important;
  line-height:1.42!important;
  font-weight:750!important;
}

#MainContent .hp-top-bullets-v42-mark{
  width:18px!important;
  height:18px!important;
  min-width:18px!important;
  margin-top:1px!important;
  border-radius:999px!important;
  background:rgba(11,37,93,.08)!important;
  color:#0b255d!important;
  display:inline-flex!important;
  align-items:center!important;
  justify-content:center!important;
  font-size:11px!important;
  line-height:1!important;
  font-weight:950!important;
}

#MainContent .hp-top-bullets-v42-text{
  flex:1 1 auto!important;
  min-width:0!important;
  direction:rtl!important;
  text-align:right!important;
}

/* Fallback if product description is already real UL/LI */
#MainContent .product__info-container .product__description ul,
#MainContent .product__info-container ul{
  max-width:390px!important;
  margin:8px auto 16px!important;
  padding:0 8px 0 0!important;
  list-style:none!important;
  direction:rtl!important;
  text-align:right!important;
}

#MainContent .product__info-container .product__description li,
#MainContent .product__info-container ul li{
  position:relative!important;
  padding-right:26px!important;
  padding-left:0!important;
  margin:6px 0!important;
  direction:rtl!important;
  text-align:right!important;
  font-family:Assistant, Arial, sans-serif!important;
  font-size:17px!important;
  line-height:1.42!important;
  font-weight:750!important;
  color:#33432a!important;
}

#MainContent .product__info-container .product__description li::before,
#MainContent .product__info-container ul li::before{
  content:"✓"!important;
  position:absolute!important;
  right:0!important;
  left:auto!important;
  top:1px!important;
  color:#0b255d!important;
  font-size:13px!important;
  font-weight:950!important;
}

/* =========================================================
   2) Collapsible sections
   ========================================================= */

#MainContent .hp-collapsible-v42-title,
#MainContent .hp-sales-pack-clean .hp-sales-pack-title-clean{
  display:block!important;
  width:100%!important;
  max-width:100%!important;
  margin:0 auto 26px!important;
  padding:0 16px!important;
  direction:rtl!important;
  text-align:center!important;
  font-family:Assistant, Arial, sans-serif!important;
  font-size:42px!important;
  line-height:1.16!important;
  font-weight:950!important;
  letter-spacing:-0.025em!important;
  transform:none!important;
  overflow:visible!important;
  white-space:normal!important;
}

#MainContent .hp-collapsible-v42-base .hp-collapsible-v42-title,
#MainContent .hp-collapsible-v42-base .hp-sales-pack-title-clean{
  color:#0E1B4D!important;
}

#MainContent .hp-collapsible-v42-max .hp-collapsible-v42-title,
#MainContent .hp-collapsible-v42-max .hp-sales-pack-title-clean{
  color:#ffffff!important;
}

@media screen and (min-width:990px){
  #MainContent .hp-collapsible-v42-list{
    width:min(900px, calc(100% - 32px))!important;
    max-width:900px!important;
    margin:0 auto!important;
    display:grid!important;
    grid-template-columns:repeat(2, minmax(0, 1fr))!important;
    gap:12px 18px!important;
    align-items:start!important;
    direction:rtl!important;
  }
}

@media screen and (max-width:989px){
  #MainContent .hp-collapsible-v42-list{
    width:100%!important;
    max-width:100%!important;
    margin:0 auto!important;
    display:block!important;
    direction:rtl!important;
  }
}

#MainContent .hp-collapsible-v42-section details,
#MainContent .hp-collapsible-v42-section .accordion{
  width:100%!important;
  max-width:100%!important;
  margin:0!important;
  padding:0!important;
  border-radius:16px!important;
  overflow:hidden!important;
  direction:rtl!important;
  text-align:right!important;
}

/* remove default marker and old weird right dot/icon */
#MainContent .hp-collapsible-v42-section summary{
  list-style:none!important;
}

#MainContent .hp-collapsible-v42-section summary::-webkit-details-marker{
  display:none!important;
}

#MainContent .hp-collapsible-v42-section summary::marker{
  content:""!important;
}

#MainContent .hp-collapsible-v42-section summary::before,
#MainContent .hp-collapsible-v42-section .accordion summary::before{
  content:none!important;
  display:none!important;
}

#MainContent .hp-collapsible-v42-section summary svg,
#MainContent .hp-collapsible-v42-section summary .icon,
#MainContent .hp-collapsible-v42-section summary .icon-caret{
  display:none!important;
  visibility:hidden!important;
  opacity:0!important;
}

/* question row */
#MainContent .hp-collapsible-v42-section summary,
#MainContent .hp-collapsible-v42-section .accordion summary{
  position:relative!important;
  width:100%!important;
  min-height:56px!important;
  margin:0!important;
  padding:16px 24px 16px 58px!important;
  display:block!important;
  direction:rtl!important;
  text-align:right!important;
  cursor:pointer!important;
  overflow:visible!important;
  font-family:Assistant, Arial, sans-serif!important;
  font-size:16.5px!important;
  line-height:1.35!important;
  font-weight:900!important;
}

/* custom plus/minus on left */
#MainContent .hp-collapsible-v42-section summary::after{
  content:"+"!important;
  position:absolute!important;
  left:22px!important;
  right:auto!important;
  top:50%!important;
  transform:translateY(-50%)!important;
  width:18px!important;
  height:18px!important;
  display:flex!important;
  align-items:center!important;
  justify-content:center!important;
  color:inherit!important;
  font-size:20px!important;
  line-height:1!important;
  font-weight:950!important;
}

#MainContent .hp-collapsible-v42-section details[open] > summary::after,
#MainContent .hp-collapsible-v42-section .accordion[open] > summary::after{
  content:"−"!important;
}

/* question text */
#MainContent .hp-collapsible-v42-section summary *,
#MainContent .hp-collapsible-v42-section .accordion summary *,
#MainContent .hp-collapsible-v42-section .accordion__title,
#MainContent .hp-collapsible-v42-section .summary__title{
  direction:rtl!important;
  text-align:right!important;
  justify-content:flex-start!important;
  margin:0!important;
  padding:0!important;
  font-family:Assistant, Arial, sans-serif!important;
  font-size:16.5px!important;
  line-height:1.35!important;
  font-weight:900!important;
  white-space:normal!important;
  overflow:visible!important;
  max-width:100%!important;
}

/* answer area */
#MainContent .hp-collapsible-v42-section .accordion__content,
#MainContent .hp-collapsible-v42-section .collapsible-content__text,
#MainContent .hp-collapsible-v42-section details > div:not(summary),
#MainContent .hp-collapsible-v42-section details > p,
#MainContent .hp-collapsible-v42-section details > span{
  display:block!important;
  width:100%!important;
  max-width:100%!important;
  height:auto!important;
  min-height:0!important;
  max-height:none!important;
  margin:0!important;
  padding:0 24px 18px 58px!important;
  direction:rtl!important;
  text-align:right!important;
  font-family:Assistant, Arial, sans-serif!important;
  font-size:15.5px!important;
  line-height:1.65!important;
  font-weight:700!important;
  white-space:normal!important;
  overflow:visible!important;
  transform:none!important;
}

#MainContent .hp-collapsible-v42-section .accordion__content *,
#MainContent .hp-collapsible-v42-section .collapsible-content__text *,
#MainContent .hp-collapsible-v42-section details[open] *:not(summary):not(summary *){
  direction:rtl!important;
  text-align:right!important;
  font-family:Assistant, Arial, sans-serif!important;
  font-size:15.5px!important;
  line-height:1.65!important;
  font-weight:700!important;
  white-space:normal!important;
  overflow:visible!important;
  max-width:100%!important;
}

#MainContent .hp-collapsible-v42-section details[open],
#MainContent .hp-collapsible-v42-section .accordion[open]{
  height:auto!important;
  min-height:0!important;
  max-height:none!important;
  overflow:visible!important;
}

@media screen and (max-width:749px){
  #MainContent .hp-top-bullets-v42{
    max-width:340px!important;
  }

  #MainContent .hp-top-bullets-v42-intro,
  #MainContent .hp-top-bullets-v42-line{
    font-size:15.5px!important;
  }

  #MainContent .hp-collapsible-v42-title,
  #MainContent .hp-sales-pack-clean .hp-sales-pack-title-clean{
    font-size:30px!important;
    line-height:1.18!important;
    margin-bottom:20px!important;
  }

  #MainContent .hp-collapsible-v42-section summary,
  #MainContent .hp-collapsible-v42-section .accordion summary,
  #MainContent .hp-collapsible-v42-section summary *,
  #MainContent .hp-collapsible-v42-section .accordion__title,
  #MainContent .hp-collapsible-v42-section .summary__title{
    font-size:15.5px!important;
    line-height:1.35!important;
  }

  #MainContent .hp-collapsible-v42-section .accordion__content,
  #MainContent .hp-collapsible-v42-section .collapsible-content__text,
  #MainContent .hp-collapsible-v42-section details > div:not(summary),
  #MainContent .hp-collapsible-v42-section details[open] *:not(summary):not(summary *){
    font-size:14.5px!important;
    line-height:1.6!important;
  }
}
`;

    document.head.appendChild(style);
  }

  function fixTopHeroBullets() {
    var descriptions = document.querySelectorAll(
      'body.template-product .product__info-container .product__description, html.hp-product-page .product__info-container .product__description'
    );

    descriptions.forEach(function (desc) {
      if (!desc || desc.dataset.hpTopBulletsV42 === '1') return;
      if (desc.querySelector('.hp-top-bullets-v42')) return;
      if (desc.querySelector('ul, ol, li')) return;

      var raw = desc.innerText || desc.textContent || '';
      var checkCount = (raw.match(/✓/g) || []).length;

      if (checkCount < 2) return;

      var parts = raw
        .split('✓')
        .map(function (part) {
          return cleanText(part);
        })
        .filter(Boolean);

      if (parts.length < 2) return;

      var intro = parts.shift();

      var html = '<div class="hp-top-bullets-v42">';

      if (intro) {
        html += '<div class="hp-top-bullets-v42-intro">' + escapeHtml(intro) + '</div>';
      }

      parts.forEach(function (line) {
        html +=
          '<div class="hp-top-bullets-v42-line">' +
            '<span class="hp-top-bullets-v42-mark">✓</span>' +
            '<span class="hp-top-bullets-v42-text">' + escapeHtml(line) + '</span>' +
          '</div>';
      });

      html += '</div>';

      desc.innerHTML = html;
      desc.dataset.hpTopBulletsV42 = '1';
    });
  }

  function commonAncestor(nodes) {
    if (!nodes || !nodes.length) return null;

    var parent = nodes[0].parentElement;

    while (parent) {
      var ok = true;

      for (var i = 0; i < nodes.length; i++) {
        if (!parent.contains(nodes[i])) {
          ok = false;
          break;
        }
      }

      if (ok) return parent;
      parent = parent.parentElement;
    }

    return null;
  }

  function markSection(section, type) {
    if (!section) return;

    section.classList.add('hp-collapsible-v42-section');

    if (type === 'base') {
      section.classList.add('hp-collapsible-v42-base');
    }

    if (type === 'max') {
      section.classList.add('hp-collapsible-v42-max');
    }

    var headings = section.querySelectorAll('h1,h2,h3,.title,.collapsible-content__heading,[class*="heading"]');

    headings.forEach(function (heading) {
      var text = cleanText(heading.textContent);

      var isBaseTitle =
        type === 'base' &&
        text.indexOf('מה כולל') !== -1 &&
        text.indexOf('HeroPack') !== -1 &&
        text.indexOf('MAX') === -1;

      var isMaxTitle =
        type === 'max' &&
        (
          text.indexOf('תוספת הפריטים') !== -1 ||
          text.indexOf('HeroPack MAX') !== -1
        );

      if (isBaseTitle || isMaxTitle) {
        heading.classList.add('hp-collapsible-v42-title');
      }
    });

    var items = Array.prototype.slice.call(section.querySelectorAll('details,.accordion'));

    if (items.length > 1) {
      var list =
        section.querySelector('.collapsible-content__grid .grid__item') ||
        section.querySelector('.collapsible-content .grid__item') ||
        section.querySelector('.collapsible-content__items') ||
        section.querySelector('.accordion-wrapper') ||
        commonAncestor(items);

      if (list && list !== section) {
        list.classList.add('hp-collapsible-v42-list');
      }
    }
  }

  function fixCollapsibles() {
    var sections = document.querySelectorAll(
      '#MainContent .shopify-section, #MainContent section, #MainContent [id^="shopify-section"]'
    );

    sections.forEach(function (section) {
      if (!section.querySelector('details,.accordion,summary')) return;

      var text = cleanText(section.textContent);

      var isBase =
        text.indexOf('מה כולל') !== -1 &&
        text.indexOf('HeroPack') !== -1 &&
        text.indexOf('HeroPack MAX') === -1;

      var isMax =
        text.indexOf('תוספת הפריטים') !== -1 &&
        text.indexOf('HeroPack MAX') !== -1;

      if (isBase) markSection(section, 'base');
      if (isMax) markSection(section, 'max');
    });
  }

  function run() {
    injectStyle();
    fixTopHeroBullets();
    fixCollapsibles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    setTimeout(run, 150);
    setTimeout(run, 700);
  });

  window.addEventListener('resize', function () {
    setTimeout(run, 150);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 150);
  });
})();

(function () {
  var STYLE_ID = 'hp-v42-final-real-fix';

  function cleanText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/[־–—]/g, '-')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
/* =========================================================
   HeroPack v42 final real fix
   1) Top HeroPack V lines aligned RTL/right
   2) Desktop collapsibles: RTL questions, fixed colors, full contrast
   ========================================================= */

/* =========================================================
   TOP HEROPACK TEXT + V LINES
   ========================================================= */

#MainContent .hp-top-v-final{
  width:100%!important;
  max-width:390px!important;
  margin:8px auto 16px!important;
  padding:0!important;
  direction:rtl!important;
  text-align:right!important;
}

#MainContent .hp-top-v-final-intro{
  margin:0 0 8px!important;
  padding:0!important;
  direction:rtl!important;
  text-align:center!important;
  color:#33432a!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:17px!important;
  line-height:1.45!important;
  font-weight:800!important;
}

#MainContent .hp-top-v-final-line{
  width:100%!important;
  display:flex!important;
  flex-direction:row!important;
  align-items:flex-start!important;
  justify-content:flex-start!important;
  gap:8px!important;

  margin:6px 0!important;
  padding:0 12px 0 0!important;

  direction:rtl!important;
  text-align:right!important;

  color:#33432a!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:17px!important;
  line-height:1.42!important;
  font-weight:750!important;
}

#MainContent .hp-top-v-final-mark{
  flex:0 0 18px!important;
  width:18px!important;
  height:18px!important;
  margin-top:1px!important;

  display:inline-flex!important;
  align-items:center!important;
  justify-content:center!important;

  color:#0b255d!important;
  background:rgba(11,37,93,.08)!important;
  border-radius:999px!important;

  font-size:11px!important;
  line-height:1!important;
  font-weight:950!important;
}

#MainContent .hp-top-v-final-text{
  flex:1 1 auto!important;
  min-width:0!important;
  direction:rtl!important;
  text-align:right!important;
}

/* fallback for real ul/li bullets */
#MainContent .product__info-container .product__description ul,
#MainContent .product__info-container ul{
  max-width:390px!important;
  margin:8px auto 16px!important;
  padding:0!important;
  list-style:none!important;
  direction:rtl!important;
  text-align:right!important;
}

#MainContent .product__info-container .product__description li,
#MainContent .product__info-container ul li{
  position:relative!important;
  margin:6px 0!important;
  padding-right:30px!important;
  padding-left:0!important;

  direction:rtl!important;
  text-align:right!important;

  color:#33432a!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:17px!important;
  line-height:1.42!important;
  font-weight:750!important;
}

#MainContent .product__info-container .product__description li::before,
#MainContent .product__info-container ul li::before{
  content:"✓"!important;
  position:absolute!important;
  right:6px!important;
  left:auto!important;
  top:1px!important;
  color:#0b255d!important;
  font-weight:950!important;
}

/* =========================================================
   COLLAPSIBLES — DESKTOP ONLY
   ========================================================= */

@media screen and (min-width:990px){

  /* כותרות באותו גודל */
  #MainContent .hp-collapsible-v42-title,
  #MainContent .hp-collapsible-v42-base .hp-collapsible-v42-title,
  #MainContent .hp-collapsible-v42-max .hp-collapsible-v42-title,
  #MainContent .hp-sales-pack-clean .hp-sales-pack-title-clean{
    font-size:38px!important;
    line-height:1.15!important;
    font-weight:950!important;
    letter-spacing:-0.025em!important;

    margin:0 auto 28px!important;
    padding:0 16px!important;

    direction:rtl!important;
    text-align:center!important;

    white-space:normal!important;
    overflow:visible!important;
    transform:none!important;
  }

  #MainContent .hp-collapsible-v42-base .hp-collapsible-v42-title{
    color:#0E1B4D!important;
  }

  #MainContent .hp-collapsible-v42-max .hp-collapsible-v42-title{
    color:#ffffff!important;
  }

  /* קונטיינר שתי עמודות */
  #MainContent .hp-collapsible-v42-list{
    direction:rtl!important;
    text-align:right!important;
  }

  /* צבעים קבועים — לא נעלם בהובר */
  #MainContent .hp-collapsible-v42-base details,
  #MainContent .hp-collapsible-v42-base .accordion{
    background:#0E1B4D!important;
    color:#ffffff!important;
    border:0!important;
    box-shadow:none!important;
  }

  #MainContent .hp-collapsible-v42-max details,
  #MainContent .hp-collapsible-v42-max .accordion{
    background:#d2cab9!important;
    color:#0E1B4D!important;
    border:0!important;
    box-shadow:none!important;
  }

  #MainContent .hp-collapsible-v42-section details:hover,
  #MainContent .hp-collapsible-v42-section .accordion:hover{
    box-shadow:none!important;
    filter:none!important;
    opacity:1!important;
  }

  #MainContent .hp-collapsible-v42-base details:hover,
  #MainContent .hp-collapsible-v42-base .accordion:hover,
  #MainContent .hp-collapsible-v42-base details:hover summary,
  #MainContent .hp-collapsible-v42-base .accordion:hover summary{
    background:#0E1B4D!important;
    color:#ffffff!important;
  }

  #MainContent .hp-collapsible-v42-max details:hover,
  #MainContent .hp-collapsible-v42-max .accordion:hover,
  #MainContent .hp-collapsible-v42-max details:hover summary,
  #MainContent .hp-collapsible-v42-max .accordion:hover summary{
    background:#d2cab9!important;
    color:#0E1B4D!important;
  }

  /* הסרת נקודות/אייקונים ישנים */
  #MainContent .hp-collapsible-v42-section summary{
    list-style:none!important;
  }

  #MainContent .hp-collapsible-v42-section summary::-webkit-details-marker{
    display:none!important;
  }

  #MainContent .hp-collapsible-v42-section summary::marker{
    content:""!important;
  }

  #MainContent .hp-collapsible-v42-section summary::before{
    content:none!important;
    display:none!important;
  }

  #MainContent .hp-collapsible-v42-section summary svg,
  #MainContent .hp-collapsible-v42-section summary .icon,
  #MainContent .hp-collapsible-v42-section summary .icon-caret{
    display:none!important;
    visibility:hidden!important;
    opacity:0!important;
  }

  /* שורת שאלה — RTL אמיתי */
  #MainContent .hp-collapsible-v42-section summary,
  #MainContent .hp-collapsible-v42-section .accordion summary{
    position:relative!important;

    display:block!important;
    width:100%!important;
    min-height:54px!important;

    margin:0!important;
    padding:15px 28px 15px 58px!important;

    direction:rtl!important;
    text-align:right!important;

    color:inherit!important;
    background:transparent!important;

    font-family:Assistant,Arial,sans-serif!important;
    font-size:16px!important;
    line-height:1.35!important;
    font-weight:900!important;

    white-space:normal!important;
    overflow:visible!important;
    cursor:pointer!important;
  }

  /* טקסט שאלה בצד ימין */
  #MainContent .hp-collapsible-v42-section summary *,
  #MainContent .hp-collapsible-v42-section .accordion summary *,
  #MainContent .hp-collapsible-v42-section .accordion__title,
  #MainContent .hp-collapsible-v42-section .summary__title{
    display:block!important;
    width:auto!important;
    max-width:100%!important;

    margin:0!important;
    padding:0!important;

    direction:rtl!important;
    text-align:right!important;
    justify-content:flex-start!important;

    color:inherit!important;
    background:transparent!important;

    font-family:Assistant,Arial,sans-serif!important;
    font-size:16px!important;
    line-height:1.35!important;
    font-weight:900!important;

    white-space:normal!important;
    overflow:visible!important;
  }

  /* פלוס/מינוס בצד שמאל */
  #MainContent .hp-collapsible-v42-section summary::after{
    content:"+"!important;
    position:absolute!important;
    left:22px!important;
    right:auto!important;
    top:50%!important;
    transform:translateY(-50%)!important;

    color:inherit!important;
    background:transparent!important;

    font-size:21px!important;
    line-height:1!important;
    font-weight:950!important;
  }

  #MainContent .hp-collapsible-v42-section details[open] > summary::after,
  #MainContent .hp-collapsible-v42-section .accordion[open] > summary::after{
    content:"−"!important;
  }

  /* תשובות — קונטרסט מלא, לא חיוור */
  #MainContent .hp-collapsible-v42-section .accordion__content,
  #MainContent .hp-collapsible-v42-section .collapsible-content__text,
  #MainContent .hp-collapsible-v42-section details > div:not(summary),
  #MainContent .hp-collapsible-v42-section details > p,
  #MainContent .hp-collapsible-v42-section details > span{
    display:block!important;

    width:100%!important;
    max-width:100%!important;
    height:auto!important;
    min-height:0!important;
    max-height:none!important;

    margin:0!important;
    padding:0 28px 18px 58px!important;

    direction:rtl!important;
    text-align:right!important;

    color:inherit!important;
    background:transparent!important;

    font-family:Assistant,Arial,sans-serif!important;
    font-size:15.5px!important;
    line-height:1.65!important;
    font-weight:800!important;

    white-space:normal!important;
    overflow:visible!important;
    transform:none!important;
  }

  #MainContent .hp-collapsible-v42-base .accordion__content,
  #MainContent .hp-collapsible-v42-base .collapsible-content__text,
  #MainContent .hp-collapsible-v42-base details[open] *:not(summary):not(summary *){
    color:#ffffff!important;
  }

  #MainContent .hp-collapsible-v42-max .accordion__content,
  #MainContent .hp-collapsible-v42-max .collapsible-content__text,
  #MainContent .hp-collapsible-v42-max details[open] *:not(summary):not(summary *){
    color:#0E1B4D!important;
  }

  #MainContent .hp-collapsible-v42-section .accordion__content *,
  #MainContent .hp-collapsible-v42-section .collapsible-content__text *,
  #MainContent .hp-collapsible-v42-section details[open] *:not(summary):not(summary *){
    direction:rtl!important;
    text-align:right!important;

    background:transparent!important;

    font-family:Assistant,Arial,sans-serif!important;
    font-size:15.5px!important;
    line-height:1.65!important;
    font-weight:800!important;

    white-space:normal!important;
    overflow:visible!important;
    max-width:100%!important;
  }

  #MainContent .hp-collapsible-v42-section details[open],
  #MainContent .hp-collapsible-v42-section .accordion[open]{
    height:auto!important;
    min-height:0!important;
    max-height:none!important;
    overflow:visible!important;
  }
}

/* מובייל — לא משנים מבנה, רק שומרים צבעים חזקים */
@media screen and (max-width:749px){
  #MainContent .hp-top-v-final{
    max-width:340px!important;
  }

  #MainContent .hp-top-v-final-intro,
  #MainContent .hp-top-v-final-line{
    font-size:15.5px!important;
  }

  #MainContent .hp-collapsible-v42-title,
  #MainContent .hp-sales-pack-clean .hp-sales-pack-title-clean{
    font-size:30px!important;
    line-height:1.18!important;
  }
}
`;

    document.head.appendChild(style);
  }

  function fixTopVLines() {
    var root = document.querySelector(
      'body.template-product .product__info-container, html.hp-product-page .product__info-container'
    );

    if (!root) return;

    if (root.querySelector('.hp-top-v-final')) return;

    var candidates = Array.prototype.slice.call(
      root.querySelectorAll('.product__description, .rte, p, div')
    ).filter(function (el) {
      if (el.dataset.hpTopVFinal === '1') return false;
      if (el.closest('form, product-form')) return false;
      if (el.querySelector('form, button, .price, .quantity, .product-form')) return false;

      var text = el.innerText || el.textContent || '';
      return (text.match(/✓/g) || []).length >= 2;
    });

    if (!candidates.length) return;

    candidates.sort(function (a, b) {
      return cleanText(a.innerText || a.textContent).length - cleanText(b.innerText || b.textContent).length;
    });

    var el = candidates[0];
    var raw = el.innerText || el.textContent || '';

    var lines = raw
      .split(/\n+/)
      .map(cleanText)
      .filter(Boolean);

    var introLines = [];
    var bulletLines = [];

    lines.forEach(function (line) {
      if (line.indexOf('✓') !== -1) {
        bulletLines.push(line);
      } else {
        introLines.push(line);
      }
    });

    if (bulletLines.length < 2) {
      var parts = raw.split('✓').map(cleanText).filter(Boolean);
      if (parts.length < 2) return;

      introLines = [parts.shift()];
      bulletLines = parts;
    }

    var html = '<div class="hp-top-v-final">';

    if (introLines.length) {
      html += '<div class="hp-top-v-final-intro">' + escapeHtml(introLines.join(' ')) + '</div>';
    }

    bulletLines.forEach(function (line) {
      var clean = cleanText(line.replace(/✓/g, ''));
      if (!clean) return;

      html +=
        '<div class="hp-top-v-final-line">' +
          '<span class="hp-top-v-final-mark">✓</span>' +
          '<span class="hp-top-v-final-text">' + escapeHtml(clean) + '</span>' +
        '</div>';
    });

    html += '</div>';

    el.innerHTML = html;
    el.dataset.hpTopVFinal = '1';
  }

  function run() {
    injectStyle();
    fixTopVLines();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    setTimeout(run, 150);
    setTimeout(run, 700);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 150);
  });
})();

(function () {
  var STYLE_ID = 'hp-top-v-lines-real-rtl-final';

  function cleanText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/[־–—]/g, '-')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
/* =========================================================
   HeroPack top V lines REAL RTL final
   ========================================================= */

#MainContent .hp-top-v-rtl-final{
  width:100%!important;
  max-width:410px!important;
  margin:8px auto 16px!important;
  padding:0!important;
  direction:rtl!important;
  text-align:right!important;
}

#MainContent .hp-top-v-rtl-final-intro{
  width:100%!important;
  margin:0 0 8px!important;
  padding:0!important;
  direction:rtl!important;
  text-align:center!important;
  color:#33432a!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:17px!important;
  line-height:1.45!important;
  font-weight:800!important;
}

#MainContent .hp-top-v-rtl-final-row{
  width:100%!important;
  display:grid!important;
  grid-template-columns:18px minmax(0,1fr)!important;
  column-gap:8px!important;
  align-items:start!important;

  margin:6px 0!important;
  padding:0!important;

  direction:rtl!important;
  text-align:right!important;

  color:#33432a!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:17px!important;
  line-height:1.42!important;
  font-weight:750!important;
}

#MainContent .hp-top-v-rtl-final-mark{
  grid-column:1!important;
  width:18px!important;
  height:18px!important;
  margin-top:1px!important;

  display:inline-flex!important;
  align-items:center!important;
  justify-content:center!important;

  border-radius:999px!important;
  background:rgba(11,37,93,.08)!important;
  color:#0b255d!important;

  font-size:11px!important;
  line-height:1!important;
  font-weight:950!important;
}

#MainContent .hp-top-v-rtl-final-text{
  grid-column:2!important;
  min-width:0!important;
  direction:rtl!important;
  text-align:right!important;
  white-space:normal!important;
}

/* גם אם נשאר UL/LI מהתבנית */
#MainContent .product__info-container .product__description,
#MainContent .product__info-container .product__description *,
#MainContent .product__info-container .rte,
#MainContent .product__info-container .rte *{
  direction:rtl!important;
}

#MainContent .product__info-container .product__description ul,
#MainContent .product__info-container ul{
  max-width:410px!important;
  margin:8px auto 16px!important;
  padding:0!important;
  list-style:none!important;
  direction:rtl!important;
  text-align:right!important;
}

#MainContent .product__info-container .product__description li,
#MainContent .product__info-container ul li{
  position:relative!important;
  margin:6px 0!important;
  padding-right:28px!important;
  padding-left:0!important;
  direction:rtl!important;
  text-align:right!important;
  color:#33432a!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:17px!important;
  line-height:1.42!important;
  font-weight:750!important;
}

#MainContent .product__info-container .product__description li::before,
#MainContent .product__info-container ul li::before{
  content:"✓"!important;
  position:absolute!important;
  right:0!important;
  left:auto!important;
  top:1px!important;
  color:#0b255d!important;
  font-weight:950!important;
}

@media screen and (max-width:749px){
  #MainContent .hp-top-v-rtl-final{
    max-width:340px!important;
  }

  #MainContent .hp-top-v-rtl-final-intro,
  #MainContent .hp-top-v-rtl-final-row{
    font-size:15.5px!important;
  }
}
`;

    document.head.appendChild(style);
  }

  function findProductInfoRoot() {
    return (
      document.querySelector('body.template-product .product__info-container') ||
      document.querySelector('html.hp-product-page .product__info-container') ||
      document.querySelector('#MainContent .product__info-container')
    );
  }

  function findBulletElement(root) {
    if (!root) return null;

    var all = Array.prototype.slice.call(root.querySelectorAll('*'));

    var candidates = all.filter(function (el) {
      if (!el || el.dataset.hpTopVRtlFinal === '1') return false;
      if (el.querySelector('.hp-top-v-rtl-final')) return false;
      if (el.closest('form, product-form')) return false;
      if (el.querySelector('form, button, .price, .quantity, .product-form, product-form')) return false;

      var text = el.innerText || el.textContent || '';
      if ((text.match(/✓/g) || []).length < 2) return false;

      var hasHeroText =
        text.indexOf('ערכת ציוד') !== -1 ||
        text.indexOf('לא צריך') !== -1 ||
        text.indexOf('כל מה שצריך') !== -1 ||
        text.indexOf('HeroPack חוסכת') !== -1;

      return hasHeroText;
    });

    if (!candidates.length) return null;

    candidates.sort(function (a, b) {
      return cleanText(a.innerText || a.textContent).length - cleanText(b.innerText || b.textContent).length;
    });

    return candidates[0];
  }

  function rebuildVLines() {
    var root = findProductInfoRoot();
    if (!root) return;

    if (root.querySelector('.hp-top-v-rtl-final')) return;

    var el = findBulletElement(root);
    if (!el) return;

    var raw = el.innerText || el.textContent || '';
    var lines = raw
      .split(/\n+/)
      .map(cleanText)
      .filter(Boolean);

    var introLines = [];
    var bulletLines = [];

    lines.forEach(function (line) {
      if (line.indexOf('✓') !== -1) {
        bulletLines.push(line);
      } else {
        introLines.push(line);
      }
    });

    if (bulletLines.length < 2) {
      var parts = raw.split('✓').map(cleanText).filter(Boolean);
      if (parts.length < 2) return;

      introLines = [parts.shift()];
      bulletLines = parts;
    }

    var html = '<div class="hp-top-v-rtl-final">';

    if (introLines.length) {
      html += '<div class="hp-top-v-rtl-final-intro">' + escapeHtml(introLines.join(' ')) + '</div>';
    }

    bulletLines.forEach(function (line) {
      var text = cleanText(line.replace(/✓/g, ''));
      if (!text) return;

      html +=
        '<div class="hp-top-v-rtl-final-row">' +
          '<span class="hp-top-v-rtl-final-mark">✓</span>' +
          '<span class="hp-top-v-rtl-final-text">' + escapeHtml(text) + '</span>' +
        '</div>';
    });

    html += '</div>';

    el.innerHTML = html;
    el.dataset.hpTopVRtlFinal = '1';
  }

  function run() {
    injectStyle();
    rebuildVLines();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    setTimeout(run, 100);
    setTimeout(run, 500);
    setTimeout(run, 1200);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 150);
  });
})();


(function () {
  var STYLE_ID = 'hp-separate-v-lines-final-css';

  function cleanText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/[־–—]/g, '-')
      .trim();
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
/* =========================================================
   HeroPack separate Text blocks V lines final fix
   Works when every V line is a separate Shopify Text block.
   ========================================================= */

#MainContent .hp-separate-v-line-final{
  width:100%!important;
  max-width:410px!important;
  margin:5px auto!important;
  padding:0 24px 0 0!important;

  display:block!important;

  direction:rtl!important;
  text-align:right!important;

  color:#33432a!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:17px!important;
  line-height:1.42!important;
  font-weight:750!important;

  white-space:normal!important;
  box-sizing:border-box!important;
}

#MainContent .hp-separate-v-line-final__inner{
  width:100%!important;

  display:flex!important;
  flex-direction:row!important;
  align-items:flex-start!important;
  justify-content:flex-start!important;
  gap:8px!important;

  direction:rtl!important;
  text-align:right!important;
}

#MainContent .hp-separate-v-line-final__mark{
  flex:0 0 18px!important;
  width:18px!important;
  height:18px!important;
  margin-top:1px!important;

  display:inline-flex!important;
  align-items:center!important;
  justify-content:center!important;

  border-radius:999px!important;
  background:rgba(11,37,93,.08)!important;
  color:#0b255d!important;

  font-size:11px!important;
  line-height:1!important;
  font-weight:950!important;
}

#MainContent .hp-separate-v-line-final__text{
  flex:1 1 auto!important;
  min-width:0!important;

  direction:rtl!important;
  text-align:right!important;

  color:#33432a!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:17px!important;
  line-height:1.42!important;
  font-weight:750!important;

  white-space:normal!important;
}

/* הכותרת הקטנה מעל הבולטים נשארת ממורכזת */
#MainContent .hp-separate-v-intro-final{
  width:100%!important;
  max-width:410px!important;
  margin:0 auto 8px!important;
  padding:0!important;

  direction:rtl!important;
  text-align:center!important;

  color:#33432a!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:17px!important;
  line-height:1.45!important;
  font-weight:800!important;
}

/* מנצח את חוקי המרכז הקודמים באזור המוצר */
body.template-product #MainContent .product__info-container .hp-separate-v-line-final,
body.template-product #MainContent .product__info-container .hp-separate-v-line-final *,
html.hp-product-page #MainContent .product__info-container .hp-separate-v-line-final,
html.hp-product-page #MainContent .product__info-container .hp-separate-v-line-final *{
  text-align:right!important;
}

@media screen and (max-width:749px){
  #MainContent .hp-separate-v-line-final,
  #MainContent .hp-separate-v-intro-final{
    max-width:340px!important;
  }

  #MainContent .hp-separate-v-line-final,
  #MainContent .hp-separate-v-line-final__text,
  #MainContent .hp-separate-v-intro-final{
    font-size:15.5px!important;
  }
}
`;

    document.head.appendChild(style);
  }

  function fixSeparateVBlocks() {
    var root =
      document.querySelector('body.template-product .product__info-container') ||
      document.querySelector('html.hp-product-page .product__info-container') ||
      document.querySelector('#MainContent .product__info-container');

    if (!root) return;

    var blocks = Array.prototype.slice.call(
      root.querySelectorAll('p, .product__text, .inline-richtext, [class*="product__text"]')
    );

    blocks.forEach(function (block) {
      if (!block || block.dataset.hpSeparateVFixed === '1') return;
      if (block.closest('form, product-form')) return;
      if (block.querySelector('form, button, .price, .quantity, product-form')) return;

      var text = cleanText(block.innerText || block.textContent || '');

      if (!text) return;

      /* השורה הראשונה: ערכת ציוד חכמה... */
      if (
        text.indexOf('ערכת ציוד חכמה') !== -1 &&
        text.indexOf('✓') === -1
      ) {
        block.classList.add('hp-separate-v-intro-final');
        block.dataset.hpSeparateVFixed = '1';
        return;
      }

      /* כל שורת V נפרדת */
      if (text.indexOf('✓') === -1) return;

      var clean = cleanText(text.replace(/✓/g, ''));

      if (!clean) return;

      block.classList.add('hp-separate-v-line-final');
      block.innerHTML =
        '<span class="hp-separate-v-line-final__inner">' +
          '<span class="hp-separate-v-line-final__mark">✓</span>' +
          '<span class="hp-separate-v-line-final__text">' + clean + '</span>' +
        '</span>';

      block.dataset.hpSeparateVFixed = '1';
    });
  }

  function run() {
    injectStyle();
    fixSeparateVBlocks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    setTimeout(run, 100);
    setTimeout(run, 500);
    setTimeout(run, 1200);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 150);
  });
})();

/* =========================================================
   HeroPack product page polish v42 - gallery/layout JS removed
   Product gallery/top-box layout is now controlled only from CSS.
   ========================================================= */
